import React from 'react';
import { createRoot } from 'react-dom/client';
import { Chart, registerables } from 'chart.js';
import { ThemeProvider } from '@mui/material/styles';
import { SnackbarProvider } from 'notistack';
import App from './App';
import { waitOnCache } from './graphql';
import theme from './theme';
import './index.scss';

// Register Chart.js components
// eslint-disable-next-line import/first
Chart.register(...registerables);

const container = document.getElementById('root');
const root = createRoot(container);

waitOnCache.then(() =>
  root.render(
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <SnackbarProvider maxSnack={1} className="snack">
          <App />
        </SnackbarProvider>
      </ThemeProvider>
    </React.StrictMode>
  )
);
